var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{},[_c('CCol',{attrs:{"col":"12","md":"6"}},[_c('EditUserFormComponent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }